/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DimensionRegression } from './DimensionRegression';
import {
    DimensionRegressionFromJSON,
    DimensionRegressionFromJSONTyped,
    DimensionRegressionToJSON,
    DimensionRegressionToJSONTyped,
} from './DimensionRegression';

/**
 * 
 * @export
 * @interface RegressionReport
 */
export interface RegressionReport {
    /**
     * 
     * @type {string}
     * @memberof RegressionReport
     */
    initiativeId?: string;
    /**
     * 
     * @type {Date}
     * @memberof RegressionReport
     */
    calculatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof RegressionReport
     */
    compositeCurrent?: number;
    /**
     * 
     * @type {number}
     * @memberof RegressionReport
     */
    compositePrevious?: number;
    /**
     * 
     * @type {number}
     * @memberof RegressionReport
     */
    compositeDelta?: number;
    /**
     * 
     * @type {string}
     * @memberof RegressionReport
     */
    overallSeverity?: string;
    /**
     * 
     * @type {Array<DimensionRegression>}
     * @memberof RegressionReport
     */
    dimensions?: Array<DimensionRegression>;
}

/**
 * Check if a given object implements the RegressionReport interface.
 */
export function instanceOfRegressionReport(value: object): value is RegressionReport {
    return true;
}

export function RegressionReportFromJSON(json: any): RegressionReport {
    return RegressionReportFromJSONTyped(json, false);
}

export function RegressionReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegressionReport {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'calculatedAt': json['calculatedAt'] == null ? undefined : (new Date(json['calculatedAt'])),
        'compositeCurrent': json['compositeCurrent'] == null ? undefined : json['compositeCurrent'],
        'compositePrevious': json['compositePrevious'] == null ? undefined : json['compositePrevious'],
        'compositeDelta': json['compositeDelta'] == null ? undefined : json['compositeDelta'],
        'overallSeverity': json['overallSeverity'] == null ? undefined : json['overallSeverity'],
        'dimensions': json['dimensions'] == null ? undefined : ((json['dimensions'] as Array<any>).map(DimensionRegressionFromJSON)),
    };
}

export function RegressionReportToJSON(json: any): RegressionReport {
    return RegressionReportToJSONTyped(json, false);
}

export function RegressionReportToJSONTyped(value?: RegressionReport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'calculatedAt': value['calculatedAt'] == null ? undefined : ((value['calculatedAt']).toISOString()),
        'compositeCurrent': value['compositeCurrent'],
        'compositePrevious': value['compositePrevious'],
        'compositeDelta': value['compositeDelta'],
        'overallSeverity': value['overallSeverity'],
        'dimensions': value['dimensions'] == null ? undefined : ((value['dimensions'] as Array<any>).map(DimensionRegressionToJSON)),
    };
}

